import React, { Component } from "react";
import PropTypes from "prop-types";

import FullScreenModal from "../../Util/FullScreenModal";
import VotifySharePartyView from "./VotifySharePartyView";

class VotifySharePartyModal extends Component {
  constructor(props) {
    super(props);

    this.state = { show: false };

    this.toggleVisibility = this.toggleVisibility.bind(this);
  }

  toggleVisibility() {
    this.setState({ show: !this.state.show });
  }

  render() {
    return (
      <FullScreenModal
        trigger={this.props.trigger}
        show={this.state.show}
        onClickTrigger={this.toggleVisibility}
      >
        <VotifySharePartyView
          partyUrl={this.props.partyUrl}
          handleClickHeader={this.toggleVisibility}
        />
      </FullScreenModal>
    );
  }
}

VotifySharePartyModal.propTypes = {
  trigger: PropTypes.object.isRequired,
  partyUrl: PropTypes.string.isRequired,
};

export default VotifySharePartyModal;
